var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('no-ssr',[_c('div',{staticClass:"root lx-loader-new",style:({ width: (_vm.sizeNumber + "px"), height: (_vm.sizeNumber + "px") })},_vm._l((8),function(i){return _c('div',{key:i,style:({ 'transform-origin': ((_vm.sizeNumber/2) + "px " + (_vm.sizeNumber/2) + "px") })},[_c('div',{staticClass:"tick",style:({
        width: (_vm.tickWidth + "px"),
        height: (_vm.tickHeight + "px"),
        left: (_vm.tickLeft + "px"),
      })})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }